import React, {useState} from 'react'
import { makeStyles, useTheme } from '@material-ui/styles';
import StoriesMain from './StoriesMain';
import DisplayOptionContext from './context/DisplayOptionContext';
import './Main.css';

const useStyles = makeStyles(theme => ({
  welcomeLogo: {
    border: `4px solid ${theme.palette.primary.main}`
  }
}))

export default function Main(props){
  const { api, isMobile, app, viewClicked } =  props

  const classes = useStyles()
  const theme = useTheme()

  const [hideWelcome, setHideWelcome] = useState(false)

  const handleCloseWelcome = () => setHideWelcome(true)
  const display = hideWelcome ? 'none' : 'block'
  const welcomeStyle = {display}

    return (
        <DisplayOptionContext.Provider value={app.displayOption}>
        <div className="welcome_over"
              style={{display, opacity:'.2', background: theme.palette.primary.main}}
              onClick={handleCloseWelcome} />
        <div className="welcome_box" onClick={handleCloseWelcome} style={welcomeStyle}>
          <div
            className={[classes.welcomeLogo, `welcome_logo`].join(` `)}
            style={{background: `url(${app.image})center center/70% no-repeat ${theme.palette.primary.main}`}} />
          <div className="welcome_title">{app.name}</div>
          <div className="welcome_explore">Explore</div>
        </div>
        <StoriesMain api={api} app={app} viewClicked={viewClicked} isMobile={isMobile} />
        <div id="endbox" className="subtitle tc maincolor hide" />
        </DisplayOptionContext.Provider>
    )
}
